module.exports = __webpack_public_path__ + "img/outlet-banner-5.d348347b.png";